<div class="overlay-inner-wrapper overlay-fullscreen">
  <div id="inspektionWrapper" class="h-100">
    <header class="header-2 scroll-x no-scroll-y">
      <div class="branding" style="min-width: 0">
        <span class="title">
          {{ 'Inspektion' | mrTranslate }}
          @if (isDevEdit) {
            - {{ 'Bearbeitungsmodus' | mrTranslate }}
          }
          - {{objektbezeichung}}
        </span>
      </div>
      <div class="header-actions">
        @if (typ_Line_Point | objtype: 'line') {
          <clr-toggle-container clrInline>
            <clr-toggle-wrapper style="margin-top: -5px">
              <label style="color: white">
                {{ 'Messung für diese Prüfung drehen' | mrTranslate }}
              </label>
              <input type="checkbox" clrToggle [(ngModel)]="isMessungDrehen" [ngModelOptions]="{ standalone: true }" />
            </clr-toggle-wrapper>
          </clr-toggle-container>

          <clr-toggle-container clrInline>
            <clr-toggle-wrapper style="margin-top: -5px">
              <label style="color: white">
                {{ 'zur Eingabe drehen' | mrTranslate }}
              </label>
              <input type="checkbox" clrToggle [(ngModel)]="drehung.isOn" [ngModelOptions]="{ standalone: true }" />
            </clr-toggle-wrapper>
          </clr-toggle-container>
        }
        <clr-date-container class="mt-0 clr-align-self-center">
          <label class="padding-5-l headerFont" for="date">
            {{ 'Inspektionsdatum' | mrTranslate }}
          </label>
          <input
            type="date"
            clrDate
            class="headerFont"
            [ngModel]="datum() | localeDate"
            (ngModelChange)="datum.set(localeDate.tosql($event))"
            [ngModelOptions]="{ updateOn: 'blur', standalone: true }" />
        </clr-date-container>
        <!-- <div class="width100 clr-align-self-center"
          style="flex: 1 1 0; max-width: 200px;">
        </div> -->
        <clr-dropdown>
          <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
            <cds-icon shape="cog" />
          </button>
          <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
            @if ((typ_Line_Point | objtype: 'point') && showChecklistenAuswahl()) {
              <clr-dropdown>
                <button clrDropdownTrigger>{{ 'Checkliste' | mrTranslate }}</button>
                <clr-dropdown-menu clrPosition="bottom-left">
                  <clr-dropdown>
                    <button clrDropdownTrigger>{{ 'Öffnen' | mrTranslate }}</button>
                    <clr-dropdown-menu clrPosition="bottom-left">
                      @for (name of checkList(); track name) {
                        <button clrDropdownItem (click)="mangelTab().applyChecklist(name, 'ersetzen')">
                          {{ name }}
                        </button>
                      }
                    </clr-dropdown-menu>
                  </clr-dropdown>
                  <button clrDropdownItem (click)="listNameModal.open()">{{ 'Speichern unter' | mrTranslate }}</button>
                  <clr-dropdown>
                    <button clrDropdownTrigger>{{ 'Fehlende Prüfarten ergänzen' | mrTranslate }}</button>
                    <clr-dropdown-menu clrPosition="bottom-left">
                      @for (name of checkList(); track name) {
                        <button clrDropdownItem (click)="mangelTab().applyChecklist(name, 'ergänzen')">
                          {{ name }}
                        </button>
                      }
                    </clr-dropdown-menu>
                  </clr-dropdown>
                </clr-dropdown-menu>
                <div class="dropdown-divider" role="separator"></div>
                <button clrDropdownItem (click)="checkMessungsVerletzungen()">
                  {{ 'Messwertverletzungen prüfen' | mrTranslate }}
                </button>
                <button clrDropdownItem (click)="mangelTab().clearMessungsVerletzungen()">
                  {{ 'alte Messwertverletzungen löschen' | mrTranslate }}
                </button>
              </clr-dropdown>
            }
            <button clrDropdownItem (click)="deletePruefung()" [disabled]="isEdit()">
              {{ 'aktuelle Inspektion löschen' | mrTranslate }}
            </button>

            @if (canDeleteMesswerteGleis()) {
              <button clrDropdownItem (click)="deleteAlteMesswerteGleis()">
                {{ 'alte Messwertverletzungen löschen' | mrTranslate }}
              </button>
            }
          </clr-dropdown-menu>
        </clr-dropdown>

        <a href="javascript://" class="nav-link nav-icon" (click)="saveInspektion()">
          <cds-icon shape="floppy" />
        </a>

        <a href="javascript://" class="nav-link nav-icon" (click)="close()">
          <cds-icon shape="window-close" />
        </a>
      </div>
    </header>
    <clr-tabs class="h-60 w-100-p overflow-tab" dynamicOverflow>
      <clr-tab>
        <button clrTabLink (click)="activeTab.set('Stammdaten')">
          {{ 'Stammdaten' | mrTranslate }}
          @if (success().stamm === false) {
            <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
          }
        </button>
        <clr-tab-content>
          <app-stammdatendialog
            [typ_Line_Point]="typ_Line_Point"
            [skipPassbild]="isDevEdit"
            [otypid]="otypid"
            [ostammid]="ostammid"
            [oldOPRUEFID]="oldOPRUEFID"
            [opruefid]="opruefid()" />
        </clr-tab-content>
      </clr-tab>
      <clr-tab>
        <button clrTabLink (click)="activeTab.set('Spezifikation')">
          {{ 'Spezifikation' | mrTranslate }}
          @if (success().spez === false) {
            <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
          }
        </button>
        <clr-tab-content>
          <app-spezifikationsdialog
            [settypeid]="typ_Line_Point"
            [setotypid]="otypid"
            [setostammid]="ostammid"
            [setstammData]="stammData"
            (changed)="mangelTab().refreshSpez()" />
        </clr-tab-content>
      </clr-tab>
      @if (typ_Line_Point == 4) {
        <clr-tab>
          <button clrTabLink (click)="activeTab.set('Bauwerke')">
            {{ 'Bauwerke' | mrTranslate }}
            @if (success().bauwerke === false) {
              <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
            }
          </button>
          <clr-tab-content>
            <app-bauwerksdialog [otypid]="otypid" [ostammid]="ostammid" [stammData]="stammData" />
          </clr-tab-content>
        </clr-tab>
      }
      <clr-tab>
        <button clrTabLink (click)="activeTab.set('Mangel')">
          {{ 'Mangel' | mrTranslate }} / {{ 'Zustand' | mrTranslate }}
          @if (success().mangel === false) {
            <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
          }
        </button>
        <clr-tab-content>
          <app-mangel-dialog
            [isInspektion]="true"
            [OPRUEFID]="opruefid()"
            [datum]="datum()"
            [typ_Line_Point]="typ_Line_Point"
            [OTYPID]="otypid"
            [OSTAMMID]="ostammid"
            [KPRUVID]="kpruvid"
            [stammData]="stammData" />
        </clr-tab-content>
      </clr-tab>
      @if (showNaturschutz()) {
        <clr-tab>
          <button clrTabLink (click)="activeTab.set('Naturschutz')">
            {{ 'Naturschutz' | mrTranslate }}
            @if (success().naturschutz === false) {
              <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
            }
          </button>
          <clr-tab-content>
            <app-naturschutzdialog [otypid]="otypid" [ostammid]="ostammid" [stammData]="stammData" />
          </clr-tab-content>
        </clr-tab>
      }
      @if (showGrundInstand()) {
        <clr-tab>
          <button clrTabLink (click)="activeTab.set('Grundinstandsetzung')">
            {{ 'Grundinstandsetzung' | mrTranslate }}
            @if (success().grundInst === false) {
              <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
            }
          </button>
          <clr-tab-content>
            <app-grundinstandsetzungdialog
              [opruefid]="opruefid()"
              [otypid]="otypid"
              [ostammid]="ostammid"
              [stammdata]="stammData"
              [typ_Line_Point]="typ_Line_Point" />
          </clr-tab-content>
        </clr-tab>
      }
      <!-- Messungen Punkt-->
      @if (messungen?.rows?.length) {
        <clr-tab class="w-100-p">
          <button clrTabLink (click)="activeTab.set('Messungen')">{{ 'Messungen' | mrTranslate }}</button>
          <clr-tab-content><app-messung-grid [messungen]="messungen" [name]="skizzeName" [OPRUEFID]="messungsOPRUEFID" /></clr-tab-content>
        </clr-tab>
      }
      @if (assignedZaehlerName(); as name) {
        <clr-tab class="zaehler w-100-p">
          <button clrTabLink (click)="activeTab.set('Zähler')">
            {{ 'Zähler' | mrTranslate }} - {{ name }}
            @if (success().zaehler === false) {
              <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
            }
          </button>
          <clr-tab-content>
            <div class="h-100 scroll padding-12"><app-zaehlertab /></div>
          </clr-tab-content>
        </clr-tab>
      }
      <!-- Historie -->
      <clr-tab class="w-100-p">
        <button clrTabLink (click)="activeTab.set('Historie')">{{ 'Historie' | mrTranslate }}</button>
        <clr-tab-content><app-historie-tree [ostammid]="ostammid" /></clr-tab-content>
      </clr-tab>
    </clr-tabs>
  </div>
</div>

<clr-modal #listNameModal [clrModalClosable]="true">
  <h3 class="modal-title">{{ 'Die Checkliste unter anderem Namen speichern' | mrTranslate }}</h3>
  <div class="modal-body clr-row nxm">
    <form
      clrForm
      class="clr-col-12 width100"
      #f="ngForm"
      clrLayout="horizontal"
      (ngSubmit)="f.valid && saveChecklist(f.value.name) && listNameModal.close()">
      @if (listNameModal._open) {
        <clr-input-container>
          <label>{{ 'Name' | mrTranslate }}</label>
          <input
            clrInput
            type="text"
            name="name"
            [autofocus]="listNameModal._open"
            [inTableValidator]="checkList()"
            doesNotInclude
            required
            ngModel
            [ngModelOptions]="{ updateOn: 'blur' }" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
          <clr-control-error *clrIfError="'in-Table'; error as err">
            {{ err | mrTranslate }}
          </clr-control-error>
        </clr-input-container>
      }
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="f.invalid" (click)="f.ngSubmit.emit()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="listNameModal.close()">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="isMessVerlModalOpen">
  <h3 class="modal-title">{{ 'Fehler Messwertverletzungen' | mrTranslate }}</h3>
  <div class="modal-body" [innerHTML]="messVerlMeldung()"></div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="isMessVerlModalOpen.set(false)">
      {{ 'OK' | mrTranslate }}
    </button>
  </div>
</clr-modal>
